import React, { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";

export default function NotificationBell({ compact }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => {
    if (!user || user.role === "customer") return;
    api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  };
  useEffect(() => {
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
    // eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  if (!user || user.role === "customer") return null;
  const unread = items.filter((n) => !n.read).length;

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && unread > 0) {
      await api.post("/notifications/read").catch(() => {});
      setTimeout(load, 400);
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} data-testid="notification-bell" className={`relative ${compact ? "p-2" : "nav-link w-full text-left"}`}>
        <Bell className="w-4 h-4" />
        {!compact && <span>Notifications</span>}
        {unread > 0 && (
          <span data-testid="notification-count" className="absolute top-0.5 left-5 min-w-[16px] h-4 px-1 rounded-full bg-red-500 text-white text-[10px] flex items-center justify-center">{unread}</span>
        )}
      </button>
      {open && (
        <div data-testid="notification-panel" className="absolute bottom-full left-0 mb-2 w-72 max-h-80 overflow-y-auto rounded-sm border border-[#2a2a2a] bg-[#0a0a0a] shadow-xl z-50 p-2 space-y-1">
          {items.length === 0 && <div className="text-xs text-zinc-500 p-3 text-center">No notifications</div>}
          {items.slice(0, 30).map((n) => (
            <button key={n.id} onClick={() => { setOpen(false); if (n.task_id) navigate("/tasks"); }}
              className={`w-full text-left px-2.5 py-2 rounded-sm text-xs border ${n.read ? "border-transparent text-zinc-500" : "border-[#D4AF37]/30 bg-[#D4AF37]/5 text-zinc-200"}`}>
              {n.message}
              <div className="text-[10px] text-zinc-600 mt-0.5">{(n.created_at || "").slice(0, 16).replace("T", " ")}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
